import React from 'react';
import { IconProps } from './IconProps';

const CashRegisterIcon: React.FC<IconProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M4 18h16" />
    <path d="M2 14h20" />
    <path d="M18 6a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2h8z" />
    <path d="M8 6h3" />
    <path d="M12 18v-4" />
    <path d="M6 18H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-2" />
  </svg>
);

export default CashRegisterIcon;
